<template>
  <hic-dialog :close-on-click-modal="true" :visible="visible" @close="cancel" append-to-body title="质控规则编辑" width="50rem" top="14vh">
    <el-form :rules="rules" inline ref="form" :model="value" @submit.native.prevent label-width="6rem">
      <el-form-item label="规则类型" prop="qcType">
        <hic-dict-selector v-model="value.qcType" dict-type="MrQCType" is-enum class="edit-input" auto />
      </el-form-item>
      <el-form-item v-if="value.qcType == '时限质控'" label="时间长度" prop="timeLimit">
        <el-input type="text" placeholder="请输入" maxlength="3" v-model.number="value.timeLimit" size="small" class="edit-input">
          <template slot="suffix">小时</template>
        </el-input>
      </el-form-item>
      <el-form-item label="问题级别" prop="errLevel">
        <hic-dict-selector v-model="value.errLevel" dict-type="MrQCErrLevel" is-enum class="edit-input" auto />
      </el-form-item>
      <el-form-item label="规则描述" prop="content">
        <el-input type="textarea" :row="3" placeholder="请输入" maxlength="255" show-word-limit v-model="value.content" size="small" style="width: 37rem" />
      </el-form-item>
      <el-form-item label="触发条件" prop="condition">
        <el-input type="textarea" :row="3" placeholder="请输入" maxlength="255" show-word-limit v-model="value.condition" size="small" style="width: 37rem" />
      </el-form-item>
      <el-form-item label="文书模板" prop="tmplCode">
        <hic-dict-selector v-model="value.tmplCode" dict-type="MrTemplate" class="edit-input" @change="tmplChanged" />
      </el-form-item>
      <el-form-item label="文书字段" prop="tmplCode">
        <el-cascader v-model="value.field" :options="fields" :props="{ expandTrigger: 'hover' }" size="small"></el-cascader>
      </el-form-item>
      <el-form-item label="停用" style="text-align: left" prop="disabled">
        <el-radio-group v-model="value.disabled">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <el-row slot="footer">
      <el-button @click.native="cancel">关 闭</el-button>
      <el-button @click="save" :loading="meta.loading" type="primary">提 交</el-button>
    </el-row>
  </hic-dialog>
</template>

<script>
  import { mapGetters } from "sw-hic";
  export default {
    components: {},
    props: {
      visible: Boolean,
      value: Object,
    },
    data() {
      var checkNum = (rule, value, callback) => {
        if (value && !Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      };
      return {
        meta: {
          loading: false,
        },
        rules: {
          content: [{ required: true, message: "请输入规则描述", trigger: "blur" }],
          timeLimit: [{ validator: checkNum, trigger: "blur" }],
          qcType: [{ required: true, message: "请选择规则类型", trigger: "change" }],
          errLevel: [{ required: true, message: "请选择问题级别", trigger: "change" }],
        },
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "dictEnum"]),
      fields() {
        if (!this?.value?.tmplCode) {
          return [];
        }
        let tmpl = this.dict.MrTemplate.find((t) => t.code == this.value.tmplCode);
        let struct = JSON.parse(tmpl?.docStruct);
        if (!struct) {
          return [];
        }
        return Object.keys(struct).map((k) => ({ value: k, label: k }));
      },
    },
    created() {},
    methods: {
      cancel() {
        // this.$emit("close");
        this.$emit("update:visible", false);
      },
      save() {
        this.$refs.form
          .validate((valid) => {
            if (valid) {
              this.$api.QcRule.save(this.value)
                .then((res) => {
                  this.$message.success("保存成功！");
                  this.$emit("saved");
                  this.cancel();
                })
                .catch((err) => {
                  this.$message.error(err);
                });
            }
          })
        
      },
      tmplChanged() {
        this.value.field = null;
      },
    },
  };
</script>
